"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("./util");
function getVariablesOffer(move, calculation, offer) {
    var _a, _b, _c, _d, _e;
    const entfernung = move.drivenDistances
        .filter((d) => d.from.type === "loadingAddress" && d.to.type === "unloadingAddress")
        .reduce((sum, d) => { var _a; return sum + ((_a = d.distance) !== null && _a !== void 0 ? _a : 0); }, 0);
    return {
        kunde: util_1.getAddressVariables(move.customer),
        beladestelle: util_1.getAddressVariables(move.loadingAddresses.length > 0
            ? move.loadingAddresses[0]
            : move.customer),
        beladestelleEinzeilig: move.loadingAddresses.length > 0
            ? getAnschriftEinzeilig(move.loadingAddresses[0])
            : getAnschriftEinzeilig(move.customer),
        entladestelle: util_1.getAddressVariables(move.unloadingAddresses[0]),
        entladestelleEinzeilig: getAnschriftEinzeilig(move.unloadingAddresses[0]),
        umfang: calculation.totalVolume,
        entfernung,
        position: {
            beladungTransport: offer.positions.loadingAndTransport,
            maut: offer.positions.toll,
            verpackungsarbeiten: offer.positions.packing,
            kleinteilepauschale: offer.positions.smallParts,
            halteverbotszonen: offer.positions.noParkingZones,
            lagerkosten: offer.positions.storage,
            besondererAufwand: offer.positions.other,
            ...Object.fromEntries(offer.positions.packingMaterial.map((packingMaterial, i) => [
                `packmaterial${i + 1}Menge`,
                packingMaterial.amount,
            ])),
            ...Object.fromEntries(offer.positions.packingMaterial.map((packingMaterial, i) => [
                `packmaterial${i + 1}Preis`,
                packingMaterial.price,
            ])),
        },
        aussenaufzug: calculation.isLiftRequired,
        entsorgung: move.rooms.some((room) => room.items.some((item) => item.disposal)),
        entsorgungKosten: offer.bulkyWasteDisposal,
        gesamtkostenOhneKundenrabatt: offer.positionsSum,
        gesamtkosten: offer.positionsSum - offer.absoluteDiscount,
        mehrwertsteuer: offer.vat,
        mehrwertsteuersatz: offer.vatRate * 100,
        versicherungsbeitrag: offer.insuranceFee,
        neuwert: move.insuranceReplacementValue,
        barzahlung: move.paymentMethod === "cash",
        beladung: {
            datum: move.loadingDates
                .map((d) => util_1.formatDate(d.date))
                .filter((d) => !!d)
                .join(" / "),
            alternativDatum: move.loadingDates
                .map((d) => util_1.formatDate(d.alternateDate))
                .filter((d) => !!d)
                .join(" / "),
            zeitraum: move.loadingDates
                .map((d) => util_1.ensureDate(d.date))
                .filter((d) => !!d)
                .map((d) => util_1.formatTimespan(d, 30))
                .join(" / "),
        },
        entladung: {
            datum: move.unloadingDates
                .map((d) => util_1.formatDate(d.date))
                .filter((d) => !!d)
                .join(" / "),
            alternativDatum: move.unloadingDates
                .map((d) => util_1.formatDate(d.alternateDate))
                .filter((d) => !!d)
                .join(" / "),
            zeitraum: move.unloadingDates
                .map((d) => util_1.ensureDate(d.date))
                .filter((d) => !!d)
                .map((d) => util_1.formatTimespan(d, 30))
                .join(" / "),
        },
        packmaterialVorab: calculation.packingMaterial.some((packingMaterial) => packingMaterial.inAdvance),
        packmaterialAnlieferungDatum: move.loadingDates
            .map((d) => util_1.formatDate(d.packingMaterialDate))
            .filter((d) => !!d)
            .join(" / ") || 0,
        angebotsdatum: util_1.formatDate((_b = (_a = move.documentData) === null || _a === void 0 ? void 0 : _a.offer) === null || _b === void 0 ? void 0 : _b.date),
        besonderheiten: (_e = (_d = (_c = move.documentData) === null || _c === void 0 ? void 0 : _c.offer) === null || _d === void 0 ? void 0 : _d.notes) !== null && _e !== void 0 ? _e : "",
        kundenrabatt: offer.absoluteDiscount,
        kundenrabattProzent: offer.relativeDiscount,
    };
}
exports.default = getVariablesOffer;
function getAnschriftEinzeilig(address) {
    const variables = util_1.getAddressVariables(address);
    return [
        variables.name,
        variables.anschrift,
        variables.anschrift2,
        `${variables.plz} ${variables.ort}`.trim(),
    ]
        .filter((p) => !!p)
        .join(", ");
}
//# sourceMappingURL=offer.js.map